export const sidebarTooltips = {
  // ORG STRUCTURE
  LEGISLATION_DATA_GROUP: 'Defines country-specific payroll and statutory rules.',
  DEPARTMENT: 'Maintains organizational departments for employee assignment and reporting.',
  DESIGNATION: 'Stores employee job titles and position hierarchy.',
  BUSINESS_TYPE: 'Defines categories of business operations.',
  COMPANY: 'Stores company/legal entity information used in payroll.',
  LOCATION: 'Maintains office and worksite locations.',
  BUSINESS_GROUP: 'Top-level organizational grouping of companies and locations.',
  MY_MODULES: 'User-specific module access and permissions.',

  // PAY FOUNDATION
  CONSOLIDATION_GROUP: 'Groups payrolls for consolidated processing and reporting.',
  PAYROLL: 'Defines payroll structures and processing rules.',
  PAY_PERIOD: 'Maintains payroll cycles such as monthly, weekly, or bi-weekly.',

  // ELEMENT SETUP
  ELEMENT_TYPE: 'Defines earnings, deductions, reimbursements, and employer contributions.',
  ELEMENT_INPUT_VALUE: 'Stores input parameters used by payroll elements.',
  ELEMENT_ELIGIBILITY: 'Defines employee eligibility criteria for payroll elements.',
  PAYROLL_FORMULA: 'Stores payroll calculation formulas and business rules.',

  // SALARY MANAGEMENT
  '__page:SALARY_TEMPLATE': 'Predefined salary structures assigned to employees.',

  // WORKFORCE
  PERSON: 'Stores employee master information.',
  ASSIGNMENT: 'Maintains employee job assignments and organizational mapping.',
  PAYROLL_RELATIONSHIP: 'Links employees to payroll processing entities.',
  ATTENDANCE: 'Stores employee attendance records.',
  LEAVE_BALANCE: 'Tracks available and utilized leave balances.',

  // SALARY & ENTRIES
  SALARY: 'Stores employee salary records and compensation details.',
  SALARY_REVISION_HISTORY: 'Maintains salary increment and revision records.',
  ELEMENT_ENTRY: 'Assigns payroll elements to employees.',
  ELEMENT_ENTRY_VALUE: 'Stores values associated with employee element entries.',

  // TAX
  TAX_DECLARATION: 'Employee investment and tax-saving declarations.',
  TAX_REGIME_CONFIG: 'Configures old and new tax regime rules.',
  FORM16_SUMMARY: 'Stores Form 16 tax computation summaries.',

  // LOANS
  ADVANCE_SALARY_POLICY: 'Defines loan eligibility and repayment policies.',
  ADVANCE_SALARY_REQUEST: 'Employee loan application records.',
  ADVANCE_SALARY: 'Approved employee loan details.',
  ADVANCE_SALARY_REPAYMENT: 'Tracks loan EMI and repayment schedules.',

  // PAYROLL RUN
  PAYROLL_RUN: 'Executes payroll calculations for a pay period.',
  RUN_RESULT: 'Stores payroll processing results.',
  RUN_RESULT_VALUE: 'Stores calculated values for payroll run results.',

  // PAYMENTS
  PERSONAL_PAYMENT_METHOD: 'Employee bank account and payment preferences.',
  PAYMENT: 'Stores payroll payment transactions.',
  PAYSLIP: 'Employee salary slip generation and records.',
  BANK_PAYMENT_FILE: 'Generates bank transfer files for salary disbursement.',

  // STATUTORY
  PF_ACCOUNT: 'Employee Provident Fund account information.',
  ESI_ACCOUNT: 'Employee State Insurance account information.',

  // MASTERS
  BANK_MASTER: 'Bank details used for payroll payments.',
  TAX_AUTHORITY: 'Government tax authority master records.',

  // LOOKUP
  CURRENCY: 'Currency master used in payroll transactions.',
  PERIOD_TYPE: 'Defines payroll period frequencies.',
  PAY_PERIOD_STATUS: 'Status tracking for payroll periods.',
  ASSIGNMENT_STATUS_MASTER: 'Employee assignment status definitions.',
  EMPLOYMENT_TYPE_MASTER: 'Employment category definitions.',
  RELATIONSHIP_TYPE_MASTER: 'Payroll relationship categories.',
  GRADE_MASTER: 'Employee grade and level definitions.',
  PROOF_TYPE_MASTER: 'Supported document/proof categories.',
  TAX_DECLARATION_STATUS_MASTER: 'Status workflow for tax declarations.',
  FORM16_GENERATION_STATUS_MASTER: 'Status tracking for Form16 generation.',
  
  // DIAGNOSTICS INTERNAL
  __group_Diagnostics: 'Internal system diagnostics, validation logs, and troubleshooting information.',

  // SCHEDULING
  WORK_SCHEDULE: 'Defines employee working schedules.',
  SHIFT_DEFINITION: 'Stores shift timings and work patterns.',
  HOLIDAY_CALENDAR: 'Maintains company holiday lists.',
  ABSENCE_TYPE: 'Defines leave and absence categories.',

  // BALANCES
  BALANCE_DEFINITION: 'Defines payroll balance calculations.',
  DEFINED_BALANCE: 'Configured balance records used in payroll.',
  BALANCE_VALUE: 'Stores calculated balance amounts.',

  // COSTING & GL
  PAYROLL_COSTING: 'Maps payroll expenses to accounting structures.',
  GL_ACCOUNT_MASTER: 'Stores General Ledger account information for payroll accounting.',
};
